module.exports = __webpack_public_path__ + "media/src/public/img/scan-08748b39fe275a11265e3379fb151115.webp";